(function($) {

  function sticky_relocate() {
    var window_top = $(window).scrollTop(),
      footer_top = $(".footer").offset().top,
      div_top = $('#sidebar1').offset().top,
      $sticky_div = $('#sidebar1 .widget_zinn_homepage_search');

    if($('.widget_black_studio_tinymce').length > 0) {
      div_top = $('.widget_black_studio_tinymce').offset().top + $('.widget_black_studio_tinymce').height() - 110;
    }
    var div_height = $sticky_div.height();
    var extra_offset = 130;

    if (window_top + div_height + extra_offset > footer_top)
      $sticky_div.hide().removeClass("fixed-filter");
    else if (window_top > div_top) {
      $sticky_div.show().addClass("fixed-filter");
    } else {
      $sticky_div.hide().removeClass("fixed-filter");
    }
  }

  $(document).ready(function(){
    $('.homepage-featured .wrapper').slick();

    // Display the search form on search icon click.
    $('.header .icon--search, .zep-mobile .icon--search').click(function (e) {
      e.preventDefault();
      $('.header__form').slideToggle('fast', function () {
        if ($(this).is(":visible")) {
          $('.search-form__input input').focus();
        }
      });
      return false;
    });

    // Hide the search form on close icon click.
    $('.header .icon--close, .zep-mobile .icon--close').click(function (e) {
      e.preventDefault();
      $('.header__form').slideToggle('fast');
      return false;
    });

    if($('form#facets_search_form').length > 0) {
      $('form#facets_search_form :input').each(function() {
        if($(this).is('select')) {
          $(this).on('change', function() {
            $(this).closest('form').submit();
          });
        }
        else {
          var field_name = $(this).attr('name');
          if(field_name != undefined) {
            if(field_name.indexOf('post_date_timestamp_str') != -1) {
              $(this).pickadate({
                format: 'mm/dd/yyyy',
                formatSubmit: 'mm/dd/yyyy',
                onOpen: function() {
                  var currentID = this.get('id');
                  var indexNumber = currentID.match(/\d+/);

                  if(indexNumber == '1') {
                    var prevID = currentID.replace('_1', '_0');

                    if($('#'+prevID).length) {
                      var minDate = $('#'+prevID).val();
                      if(minDate != '') {
                        var timestamp = Date.parse(minDate);
                        this.set('min', new Date(timestamp));
                      }
                    }
                  }
                }
              });
            }
          }
        }
      });
    }
    if($('form#this-day-in-history-search-form').length > 0) {
      $('input[name="homepage_search_history_date"]').pickadate({
        format: 'mm/dd/yyyy',
        formatSubmit: 'mm/dd/yyyy'
      });
    }

    if($('input[name="homepage_search_posting_date"]').length > 0) {
      $('input[name="homepage_search_posting_date"]').pickadate({
        format: 'mm/dd/yyyy',
        formatSubmit: 'mm/dd/yyyy'
      });
    }

    // Collapsible block.
    $('.block__title').click(function () {
      var $this = $(this);
      $this.siblings('.block__content').slideToggle('fast', function () {
        if ($(this).is(':visible')) {
          $(this).css('overflow', 'visible');
        }
      });

      $this.parent().toggleClass('expanded');
    });

    $('select[name="country"]').on('change', function() {
      if($(this).val() == 'US') {
        $('#state_select_cnt').css('display', 'block');
        $('#state_input_cnt').css('display', 'none');
        $('input[name="state_input"]').val('');
      }
      else {
        $('#state_select_cnt').css('display', 'none');
        $('#state_input_cnt').css('display', 'block');
        $('select[name="state"]').val('');
      }
    });

    var label_extra_text = '';
    var required_registration_fields = [
      'user_login',
      'user_email',
      'user_email_2',
      'pass1',
      'pass2',
      'first_name',
      'last_name'
    ];

    for(var i=0; i<required_registration_fields.length; i++) {
      label_extra_text = '';

      switch(required_registration_fields[i]) {
        case 'pass1':
          label_extra_text = ' (must be at least 6 characters)<span class="label-required">*</span>';
          break;
        case 'pass2':
          label_extra_text = ' (Verify match)<span class="label-required">*</span>';
          break;
        default:
          label_extra_text = '<span class="label-required">*</span>';
          break;
      }

      if(label_extra_text != '' && $('#registerform label[for="'+ required_registration_fields[i] +'"]').length > 0) {
        $('#registerform label[for="'+ required_registration_fields[i] +'"]').append(label_extra_text);
      }
    }

    $('#userphoto').css('display', 'none');

    // Fixed div filter on scroll, on material page.
    if ($('body').hasClass('single-materials') ||
      $('body').hasClass('search-results')) {
      var windowSize = $(window).width();

      $(window).on('scroll', function () {
        if (windowSize >= 1024) {
          sticky_relocate();
        }
      });

      $(window).on('resize', function () {
        windowSize = $(window).width();

        if (windowSize >= 1024) {
          sticky_relocate();
        }
      });
    }

    var section = [];

    var new_div;
    // go through all the Gravity Forms fields
    $('.gfield').each( function() {
      // if the field is a section create a new array for fields and a new container to append the fields
      if ( $(this).hasClass('collapsible') ) {
        if ( section.length > 0 ) {
          section = [];
        }
        new_div = $('<div class="m_section"></div>');
        new_div.insertAfter($(this));
      } else {
        // check if the field is the the kind you want to use for the accordion
        if ( $(this).hasClass('collapse_field')) {
          // if it's the first element add a custom text to the section name
          if ( section.length == 0 ) {
            $(this).prevAll(".collapsible:first").find('.gsection_title');
          }
          // add the field to the section array for reference
          section.push($(this));
          // move the field in the container for the section
          if ( new_div ) {
            new_div.append($(this));
          }
        }
      }
    });

    // add the section click behavior
    $('.collapsible').click(function(e) {
      e.preventDefault();
      // toggle the text

      $(this).next().slideToggle('fast', function () {
        $(this).toggleClass('show_collapse');
      });

      $(this).toggleClass('expanded');
    });

    // hide all section containers on first run, can be replaced by a css rule
    $('.m_section').hide();

    var max_length = 18;

    if($('body').hasClass('single-materials')) {
      max_length = 28;
    }
    if($('#this-day-in-history-search-form').length > 0) {
      max_length = 12;
    }

    $('#materials-search-form select, #this-day-in-history-search-form select').each(function() {
      var selected_option = $(this).find('option:selected');

      if(selected_option.attr('data-option-title')) {
        var option_title = selected_option.attr('data-option-title');

        if(option_title.length > max_length) {
          option_title = option_title.substr(0, max_length) + '...';
        }

        selected_option.text(option_title);
      }
    });

    $('#materials-search-form select, #this-day-in-history-search-form select').on('change',function(){
      $(this).find('option').each(function() {
        if($(this).attr('data-option-title')) {
          var option_title = $(this).attr('data-option-title');

          if($(this).is(':selected')) {
            if(option_title.length > max_length) {
              option_title = option_title.substr(0, max_length) + '...';
            }
          }

          $(this).text(option_title);
        }
      });
    });

    $('.resource-autocomplete input').autoComplete({
      source: function(name, response) {
        $.ajax({
          type: 'POST',
          dataType: 'json',
          url: '/wp-admin/admin-ajax.php',
          data: 'action=get_resource_posts&name='+name,
          success: function(data) {
            response(data);
          }
        });
      }
    });
  });

}(jQuery));
